export const Features = {
  DOWNLOAD_REQUEST: {
    TYPE: 'download-request',
    LEGACY_DOWNLOAD_REQUEST: 'use-legacy-download-request'
  }
}
